import { render } from "./ComebackBreakdownStats.vue?vue&type=template&id=0da0e8ab&scoped=true"
import script from "./ComebackBreakdownStats.vue?vue&type=script&lang=js"
export * from "./ComebackBreakdownStats.vue?vue&type=script&lang=js"

import "./ComebackBreakdownStats.vue?vue&type=style&index=0&id=0da0e8ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da0e8ab"]])

export default __exports__